var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.favorite || _vm.blacklisted
    ? _c(
        "v-chip",
        {
          staticClass: "mr-1 px-2",
          class: _vm.favorite ? "favorite" : "blacklisted",
          attrs: {
            color: _vm.favorite ? "#F6B10033" : "#F8285A33",
            dark: "",
            "x-small": "",
          },
        },
        [
          _vm.favorite
            ? _c(
                "span",
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-1", attrs: { "x-small": "" } },
                    [_vm._v("mdi-heart")]
                  ),
                  _vm._v(" "),
                  _c("b", [_vm._v("Favorit")]),
                ],
                1
              )
            : _c(
                "span",
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-1", attrs: { "x-small": "" } },
                    [_vm._v("mdi-cancel")]
                  ),
                  _vm._v(" "),
                  _c("b", [_vm._v("Negativ Liste")]),
                ],
                1
              ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }